// The static public/index.html ships in Spanish (what crawlers and link
// previews see). When the visitor is reading another language, keep the
// browser-visible document metadata in step: <html lang>, the tab title and
// the description / social tags.
const HTML_LANG = { es: "es-MX", en: "en" };
const OG_LOCALE = { es: "es_MX", en: "en_US" };

function setMeta(selector, value) {
  const el = document.querySelector(selector);
  if (el && value) el.setAttribute("content", value);
}

export function syncDocument(language, t) {
  const lng = language === "en" ? "en" : "es";

  document.documentElement.lang = HTML_LANG[lng];
  document.title = t("meta.title");

  setMeta('meta[name="description"]', t("meta.description"));
  setMeta('meta[name="keywords"]', t("meta.keywords"));
  setMeta('meta[property="og:title"]', t("meta.ogTitle"));
  setMeta('meta[property="og:description"]', t("meta.ogDescription"));
  setMeta('meta[property="og:locale"]', OG_LOCALE[lng]);
  setMeta('meta[name="twitter:title"]', t("meta.ogTitle"));
  setMeta('meta[name="twitter:description"]', t("meta.twitterDescription"));
}
